import React from 'react';
import { connect } from 'react-redux';

import Dashboard from '../dashboard/Dashboard.screen';
import WelcomeScreen from '../../components/Welcome/WelcomeScreen';
import SubMerchantDashboard from '../dashboard/SubMerchantDashboard';
import ClientDashboard from '../dashboard/ClientDashboard';
import ViewCampaignCodes from '../ViewCampaignCodes/ViewCampaignCodes';
import MerchantGreetlyVouchers from '../GreetlyVouchers/MerchantGreetlyVouchers';
import {
  getGreetlyMerchant,
  isGreetlyOnlyAccess,
} from '../../constants/greetlyPortal';

const Home = (props) => {
  const greetlyOnly = isGreetlyOnlyAccess(
    props.auth.details.portalAccess,
    getGreetlyMerchant(props.user)
  );

  const renderRoleBased = () => {
    if (greetlyOnly) return <MerchantGreetlyVouchers />;
    switch (props.auth.details.role) {
      case 'ROLE_THYAGA_ACCOUNTANT':
      case 'ROLE_THYAGA_ADMINISTRATOR':
      case 'ROLE_THYAGA_CUSTOMER_CARE':
      case 'ROLE_THYAGA_MERCHANT_CONTROLLER':
        return <WelcomeScreen />;
      case 'ROLE_SUB_MERCHANT_ADMINISTRATOR':
        return <SubMerchantDashboard />;
      case 'ROLE_REWARD_CLIENT_USER':
        return <ClientDashboard />;
      case 'ROLE_CLIENT_CAMPAIGN_ADMINISTRATOR':
        return <ViewCampaignCodes />;
      default:
        return <Dashboard />;
    }
  };

  return <div>{renderRoleBased()}</div>;
};

const mapStateToProps = (state) => ({
  auth: state.auth.auth,
  user: state.user,
});

export default connect(mapStateToProps)(Home);
